import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIsGeneralStepVisited = new ReduxAsyncAction<
  'UPDATE_IS_GENERAL_STEP_VISITED',
  boolean,
  { isGeneralStepVisited: boolean }
>('UPDATE_IS_GENERAL_STEP_VISITED');

UpdateIsGeneralStepVisited.registerRequest(async (isGeneralStepVisited: boolean) => {
  return {
    isGeneralStepVisited,
  };
});

export const UPDATE_IS_GENERAL_STEP_VISITED = UpdateIsGeneralStepVisited.actionNamespaceConstants;

export const updateIsGeneralStepVisited = UpdateIsGeneralStepVisited.request;

export type UpdateIsGeneralStepVisitedResponseAction = Action<typeof UPDATE_IS_GENERAL_STEP_VISITED.response> & {
  data: { isGeneralStepVisited: boolean };
};
